/**
 * hooks/useLocalization.js
 * Хук для доступа к переводам внутри компонентов.
 * Возвращает функцию t(key, vars?) привязанную к текущему языку.
 */
import { useCallback } from 'react';
import { useWidget } from '@/state/WidgetContext';
import { translate, getTextDirection } from '@/services/localization';

export function useLocalization() {
  const { state } = useWidget();
  const { language } = state;

  /** t('welcome.message') или t('contacts.emailLabel') */
  const t = useCallback(
    (key, vars = {}) => translate(language, key, vars),
    [language],
  );

  const dir = getTextDirection(language);
  const isRtl = dir === 'rtl';

  return { t, language, dir, isRtl };
}
